import {
  getAction,
  postAction,
  deleteAction,
  downloadFile,
  putAction
} from './request';

export const logout = () => postAction('/sys/logout', {});

export const loginUser = params => postAction('/customer/login', params);
export const getValidateCode = key => getAction(`/sys/randomImage/${key}`);
export const getAllLocales = params =>
  getAction('/locale/queryAllList', params);
export const queryAllLanguage = () => getAction('/locale/queryAllList');
export const queryAllEnabledLanguage = () =>
  getAction('/locale/queryAllEnAbleList');
export const queryAllInternation = params =>
  getAction('/internation/queryAllInternation', params);
export const queryCountryList = () => getAction('/customer/queryCountryList');

// 整车
export const getVehicleList = params =>
  getAction('/vehicle/queryPageForCustomer', params);

export const getVehicleListByType = params =>
  getAction('/vehicle/queryByTypeId', params);

export const getVehicleById = params => getAction('/vehicle/queryById', params);

export const getVehicleDropdownList = params =>
  getAction('/vehicle/queryList', params);

// 配件
export const getPartList = params =>
  getAction('/parts/queryPageForCustomer', params);

export const getPartPartsList = params =>
  getAction('/parts/queryPartsPageForCustomer', params);

export const getPartDetail = params =>
  getAction('/parts/queryPartsDetail', params);

export const getUniqueVin = params =>
  getAction('/parts/queryByIdsAndName', params);

// 整车颜色
export const getAllVehicleColorList = params =>
  getAction('/vehicle-color/queryColorList', params);

// 购物车
export const addToCart = params =>
  postAction('shopping_cart/addToCart', params);

export const getShoppingcartPage = params =>
  getAction('/shopping_cart/queryPageList', params);

export const deleteShoppingcart = params =>
  deleteAction('/shopping_cart/deleteById', params);

export const modifyShoppingcart = params =>
  postAction('/shopping_cart/modifyById', params);

export const deleteShoppingcartItemById = params =>
  deleteAction('/shopping_cart/deleteByIds', params);

export const submitOrder = params =>
  postAction('/shopping_cart/submitOrder', params);

export const importPartFile = params =>
  postAction('/shopping_cart/importPartsInfo', params);

export const submitImportOrder = () =>
  postAction('/shopping_cart/submitOrderImport', {});

export const getImportTotalPrice = () =>
  getAction('/shopping_cart/calculateTotalPrice', {});

// Customer
export const getAllCustomerCompany = params =>
  getAction('customer/queryCustomerCompany', params);

// 首页
export const getHomePageData = () => getAction('/indexConfig/queryList');

// 整车类型
export const getVehicleTypeList = () =>
  getAction('/vehicle-type/queryTypeList');

// 新闻列表 - 工厂秀
export const getAllNewsList = () => getAction('/news/queryAllNews');

export const getFactories = params => getAction('/news/queryNewsByIds', params);

// 文章列表 - about us
export const getArticleListByTypes = params =>
  getAction('/article/queryByTypes', params);

// 下载中心 - download center
export const getDownloadFileByType = params =>
  getAction('/fileDownloadCenter/queryByType', params);



// 文件模板

export const getTemplateFile = (fileName, params) =>
  downloadFile('/fileTemplate/download', fileName, params);

// 订单

export const getOrderList = params => getAction('/order/queryPageList', params);

export const modifyOrder = params => putAction('/order/update', params);

export const getOrderDetail = params => getAction('/order/detail', params);

export const copyOrder = params => getAction('/order/reorder', params);

// 国际化
export const getInternaion = params =>
  getAction('/internation/queryByType', params);

// 物流

export const getLogisticsList = params =>
  getAction('/order_logistics/queryPage', params);

export const modifyLogisitics = params =>
  putAction('/order_logistics/edit', params);

export const getLogisiticsListByOrder = params =>
  getAction('/order_logistics/queryLogisticPageByOrderId', params);

export const getLogisticsRelList = params =>
  getAction('/order_logistics/getOrderLogisticsRels', params);

export const getLogisticsBatchList = params =>
  getAction('/order_logistics/queryPageByBatch', params);

export const getLogisticsDetail = params =>
  getAction('/order_logistics/getDetail', params);

//产品咨询
export const addGuestFeedback = params =>
  postAction('/guest/feedback/addGuestFeedback', params);
